import React from "react";
import OverTimeChart1 from "../../../../components/question-components/charts/OverTimeChart1";
import OverTimeChart2 from "../../../../components/question-components/charts/OverTimeChart2";
import OverTimeChart3 from "../../../../components/question-components/charts/OverTimeChart3";

const QuestionOverTime = () => {
  return (
    <div>
      <div>
        <h1>Question performance over time</h1>
        <p>
          The charts below show you your performance in the main question bank
          since the start of your account.
        </p>
      </div>

      <div>
        <div>
          <h5>Cumulative average score</h5>
          <hr />
          <p>
            The chart below shows how your has changed since you started
            answering questions. It is based on first attempts to allow
            meaningful comparisons with other users. If at any point you've
            reset your account the data will also have been reset.
          </p>
          <div>
            <OverTimeChart1 />
          </div>
        </div>
        <div>
          <h5>Weekly aggregate average scores</h5>
          <hr />
          <p>
            This chart shows how your performance has changed over time using
            weekly aggregate average scores. Again it is based on first
            attempts.
          </p>
          <div>
            <OverTimeChart2 />
          </div>
        </div>
        <div>
          <h5>Number of questions attempted</h5>
          <hr />
          <p>
            The number of questions you have attempted since the start of your
            subscription (or since you reset your account) is shown below.
          </p>
          <div>
            <OverTimeChart3 />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionOverTime;
